import { memo, useState } from 'react';
import { StatusCard } from 'components/index';
import { useClient } from 'hooks/webapi';
import { useSoldDebt } from 'hooks/useSoldDebt';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';
import styles from './ModalSoldDebt.module.scss';

export const SOLD_DEBT_MODAL_HIDDEN = 'soldDebtModalHidden';

export default memo(function ModalSoldDebt() {
  const { client } = useClient();
  const { t } = useTranslation('common');
  const { message } = useSoldDebt({ soldDebtMessage: client?.soldDebtMessage });
  const [showModal, setShowModal] = useState(
    sessionStorage.getItem(SOLD_DEBT_MODAL_HIDDEN) !== 'true' &&
      Boolean(message),
  );

  if (!showModal) return null;

  const onClose = () => {
    sessionStorage.setItem(SOLD_DEBT_MODAL_HIDDEN, 'true');
    setShowModal(false);
  };

  return (
    <Modal
      contentClassName={styles['modal-wrapper']}
      dataTest="modalSoldDebt"
      onClose={onClose}
    >
      <StatusCard
        button={t('understood')}
        className={styles.card}
        description={message}
        descriptionClassName={styles.description}
        onClick={onClose}
        type="rejected"
      />
    </Modal>
  );
});
